import {defineStore} from 'pinia'

export const useCounterStore = defineStore('counter', {
    state: () => ({
        count: 0,
    }),
    getters: {
        getDoubleCount(state) {
            return this.count * 2
        },
    },
    actions: {
        increment() {
            this.count++
        },
        resetCount(){
            this.count = 0
        }
    },
    persist: {
        paths: ['count'],
    },
})
